import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import BookCard from "../resultcards/BookCard.jsx";
import EventCard from "../resultcards/EventCard.jsx";
import FacetList from "../components/FacetList.jsx";
import InTheNewsCard from "../resultcards/InTheNewsCard.jsx";
import Pager from "../components/Pager.jsx";
import PaperCard from "../resultcards/PaperCard.jsx";
import CenterPaperCard from "../resultcards/CenterPaperCard.jsx";
import PersonCard from "../resultcards/PersonCard.jsx";
import ResultSummary from "../components/ResultSummary.jsx";
import SortToggle from "../components/SortToggle.jsx";
import StoryCard from "../resultcards/StoryCard.jsx";
import PerPageSelector from "../components/PerPageSelector.jsx";
import EventTypeToggle from "../components/EventTypeToggle.jsx";
import FacetToggle from "../components/FacetToggle.jsx";

export default class Listing extends React.Component {
  constructor(props) {
    super(props);
  }

  renderItem = (item, i, dateFormat) => {
    const { data, loading, wrapperid } = this.props;
    // console.log(item);
    switch (item.type) {
      case "entity:user":
        return (
          <PersonCard key={i}
            index={i}
            loading={loading}
            {...item}
          />
        );
      case "conference":
        return (
          <EventCard key={i}
            index={i}
            loading={loading}
            {...item}
          />
        );
      case "book":
      case "chapter":
      case "lecture":
        return (
          <BookCard key={i}
            index={i}
            loading={loading}
            dateFormat={dateFormat}
            {...item}
          />
        );
      case "news_reference":
        return (
          <InTheNewsCard key={i}
            index={i}
            loading={loading}
            {...item}
          />
        );
      case "center_paper":
        return (
          <CenterPaperCard key={i}
           index={i}
           {...item}
          />
        );
      case "working_paper":
        return (
          <PaperCard key={i}
            index={i}
            {...item}
          />
        );
      case "web_story":
        return (
          <StoryCard key={i}
            index={i}
            {...item}
          />
        );
      default:
        return (
          <BookCard key={i}
            index={i}
            loading={loading}
            dateFormat={dateFormat}
            {...item}
          />
        );
    }
  }

  render() {
    const { config, data, handleUpdate, loading } = this.props;
    const {
      checkboxLabel = 'Mark to make your selection',
      checkboxType,
      dateFormat,
      dictionary,
      eventLinksDivider,
      eventTypeLinks,
      facetsLinks,
      forceFilters,
      hiddenFacets,
      id,
      perPageOptions,
      showCalendar,
      dateType = 'default',
      dateLabelFormat = 'MMMM do, yyyy',
      showEventTypeLinks,
      showFacetAsLinks,
      showNewKey,
      showResultsSummary,
      sorters,
    } = config;
    const { request, results, totalResults } = data;
    const { resultsTitle, searchBoxLabel, sortLabel, title, perPageLabelBefore, perPageLabelAfter } = dictionary;
    let facets = data.facets;

    const queryInfo = {
      label: searchBoxLabel,
      id: id + "query",
      handleUpdate: handleUpdate,
      q: request.q
    };

    const dateInfo = showCalendar ? {
      endDate: (request.endDate) ? request.endDate : "",
      id: id,
      showLabel: true,
      startDate: (request.startDate) ? request.startDate : "",
    } : false;

    // If the hidden facets option is enabled remove those from the regular facets list.
    // Can be used alongside the Facets Toggles to improve UX and navigation.
    if (typeof showFacetAsLinks !== 'undefined' && showFacetAsLinks) {
      const facetsList = (typeof facetsLinks !== 'undefined') ? facetsLinks.map((link) => link.id) : [];
      if (facetsList && facets && hiddenFacets) {
        facets = facets.filter((item) => (hiddenFacets.indexOf(item.id) === -1));
      }
    }

    const showFacets = facets && facets.length > 0 || forceFilters;

    const searchClass = classNames("search", {
      "is-loading": loading
    });

    return (
      <div className={ searchClass }>
        <div className="visually-hidden" aria-live="polite">{ loading && "Loading" } { !loading && "Loding Complete" }</div>
        {showFacets && <FacetList
          checkboxType={ checkboxType }
          checkboxLabel={ checkboxLabel }
          dateType={ dateType }
          dateInfo={ dateInfo }
          dictionary={ dictionary }
          facets={ facets }
          selectedFacets={ request.facet }
          selectedFacetsPosition={ "bottom" }
          handleUpdate = { (params) =>{
              handleUpdate(params);
            }
          }
          dateLabelFormat={ dateLabelFormat }
          horizontal={ true }
          queryInfo={ queryInfo }
          dateLabelFormat={ dateLabelFormat } /> }
        <div id={ resultsTitle.match(/working\spaper/i) ? 'working-papers-listing' : '' } className={ resultsTitle.match(/working\spaper/i) ? 'page-subtitle page-subtitle--centered working-papers-listing' : 'page-subtitle page-subtitle--centered' }>
          { resultsTitle && <h2 className="page-subtitle__title">{ resultsTitle }</h2> }
          <div className="page-subtitle__info-bar">
            { showResultsSummary && <ResultSummary
                dictionary={ dictionary }
                page={ parseInt(request.page) }
                perPage={ parseInt(request.perPage) }
                totalResults={ totalResults } />}
            { results.length > 0 && sorters && <span className="page-subtitle__info-bar-divider">{" | "}</span> }
            { results.length > 0 && sorters && <SortToggle
                handleUpdate = { handleUpdate }
                sortLabel={ sortLabel }
                sorters={ sorters }
                sortBy={ request.sortBy } /> }
            { (showNewKey || showResultsSummary || sorters) && results.length > 0 && <span className="page-subtitle__info-bar-divider">{" | "}</span> }
            { results.length > 0 && <PerPageSelector
                handleUpdate = { handleUpdate }
                perPageLabelBefore={ perPageLabelBefore }
                perPageLabelAfter={ perPageLabelAfter }
                perPageOptions={ perPageOptions }
                perPage={ request.perPage } /> }
          </div>
          { showNewKey && <div className="is-new"><div className="digest-card__title">New This Week</div></div> }
          { showEventTypeLinks && <EventTypeToggle handleUpdate = {handleUpdate}
                                                    eventType={ request.eventType }
                                                    eventTypeLinks={ eventTypeLinks}
                                                    eventLinksDivider={(typeof eventLinksDivider !== 'undefined') ? eventLinksDivider : ' | ' } /> }

           { showFacetAsLinks && <FacetToggle
                handleUpdate={(params) =>{
                  handleUpdate(params);
                }}
                selectedFacets={ request.facet }
                facetLinks={facetsLinks}
              />
           }
        </div>
        { results.length > 0 && <div className="promo-grid promo-grid--2-up">
          <div className="promo-grid__promos">
            { results.map((result, i) => this.renderItem(result, i, dateFormat)) }
          </div>
        </div> }
        <div className="search__pager-wrapper">
        { results.length > 0 && <Pager
          handleUpdate = { handleUpdate }
          page={ parseInt(request.page) }
          perPage={ parseInt(request.perPage) }
          totalResults={ totalResults } /> }
        { results.length > 0 && <PerPageSelector
            handleUpdate = { handleUpdate }
            perPageLabelBefore={ perPageLabelBefore }
            perPageLabelAfter={ perPageLabelAfter }
            perPageOptions={ perPageOptions }
            perPage={ request.perPage } /> }
        </div>
      </div>
    );
  }

  componentDidMount() {
    const hash = document.location.hash,
    el = hash ? document.querySelector(hash) : false;
    if (el) {
      el.scrollIntoView();
    }
  }
}

const { bool, func, object} = PropTypes;

Listing.propTypes= {
  config: object.isRequired,
  data: object.isRequired,
  handleUpdate: func.isRequired,
  loading: bool
};
